<template>
  <Catalogs
    title="Виды работ"
    create-text="Новый"
    :fetch-data="fetchData"
    :fields="fields"
    :route-create="'WorkTypeCatalogAdd'"
    :route-edit="'WorkTypeCatalogEdit'"
    :route-view="'WorkTypeCatalogView'"
    :route-path="'/work_type_catalogs'"
    :can-edit="canEditWorkTypeCatalogs()"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import Catalogs from "../Catalogs.vue";

export default {
  name: "WorkTypeCatalogs",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions
  ],
  data() {
    return {
      fields: [
        {
          key: 'id',
          sortable: true,
          class: 'work-type-id'
        },
        {
          key: 'name',
          label: "Название",
          sortable: true,
        },
        {
          key: 'active',
          label: "Активный",
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'action',
          label: "Действия",
          class: 'work-type-action'
        },
      ],
    }
  },
  methods: {
    async fetchData(data) {
      return await this.getWorkTypeCatalogs(data);
    },
    canEditWorkTypeCatalogs() {
      return this.hasPermission([PERM.CATALOG_WORK_TYPE_EDIT]);
    }
  }
}
</script>

<style>
.work-type-id {
  padding-left: 10px !important;
  width: 60px;
  text-align: center;
}

.work-type-action {
  width: 80px;
  padding-right: 10px !important;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/WorkType/WorkTypeCatalogs.vue